import { render, staticRenderFns } from "./InsuredsListItem.vue?vue&type=template&id=76f80d2a&"
import script from "./InsuredsListItem.vue?vue&type=script&lang=js&"
export * from "./InsuredsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports